import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useCreateRoleMutation } from "../rolesApi";

const RoleCreateModal = ({ show, onClose }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [createRole, { isLoading }] = useCreateRoleMutation();

  const handleClose = () => {
    reset();
    onClose();
  };

  const onSubmit = async (values) => {
    try {
      await createRole({
        roleCode: values.roleCode.trim().toUpperCase(),
        roleName: values.roleName.trim(),
        grantsAllBranchAccess: Boolean(values.grantsAllBranchAccess),
      }).unwrap();
      toast.success("Role created");
      handleClose();
    } catch (error) {
      toast.error(error?.message || "Could not create role");
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Role</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Role Code</label>
            <input
              type="text"
              className="form-control"
              placeholder="e.g. OPERATIONS_MANAGER"
              {...register("roleCode", { required: true })}
            />
            <small className="text-muted">
              Immutable once created - used as a stable key.
            </small>
            {errors.roleCode && (
              <div className="text-danger">Role code is required</div>
            )}
          </div>
          <div className="mb-3">
            <label className="form-label">Role Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="e.g. Operations Manager"
              {...register("roleName", { required: true })}
            />
            {errors.roleName && (
              <div className="text-danger">Role name is required</div>
            )}
          </div>
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="grantsAllBranchAccess"
              {...register("grantsAllBranchAccess")}
            />
            <label
              className="form-check-label"
              htmlFor="grantsAllBranchAccess"
            >
              Grants all-branch access
            </label>
            <div>
              <small className="text-muted">
                Only for genuine cross-branch admin roles.
              </small>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={isLoading}>
            {isLoading ? "Creating..." : "Create Role"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default RoleCreateModal;
